import React from 'react';
import {
  Box,
  Typography,
  Button,
  Modal as MuiModal,
} from '@mui/material';
import MDButton from 'mdComponents/MDButton';
import { APP_NAME } from '../../constants';

interface AlertProps {
  visible: boolean;
  isFreeForeverHost?: boolean;
  onChangePricing: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const RemoveLocationModal: React.FC<AlertProps> = ({
  visible,
    isFreeForeverHost,
    onChangePricing,
    onConfirm,
    onCancel
}) => {
  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 600,
          maxWidth: '100%',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" mb={1}>
          Remove Location from {APP_NAME}?
        </Typography>

        {isFreeForeverHost && (
            <Typography variant="body2" mb={3}>
                Please note, this location is free forever and will not be free to restore if canceled!
            </Typography>                
        )||( 
        <Typography variant="body2" mb={3}>
                Please note, if you wish to change your pricing plan you can do so without cancelling.
        </Typography>
        )}






        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <MDButton variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </MDButton>
          {!isFreeForeverHost &&
          <MDButton color="dark" onClick={onChangePricing}>
            Change Hosting Plan
          </MDButton>}
          <MDButton color="error" onClick={onConfirm}>
            Remove this Location
          </MDButton>
        </Box>
      </Box>
    </MuiModal>
  );
};

export default RemoveLocationModal;
